import React, { useState } from "react";
import { Form, Row, Col } from "react-bootstrap";
import Select from "react-select";

const temperatureUnits = [
  { value: "celsius", label: "°C" },
  { value: "fahrenheit", label: "°F" },
  { value: "kelvin", label: "K" }
];

const windSpeedUnits = [
  { value: "mph", label: "mph" },
  { value: "kph", label: "kph" },
  { value: "m/s", label: "m/s" },
  { value: "knots", label: "knots" }
];

const EnvironmentalConditions = ({ envData, setEnvData }) => {
  const [minTemp, setMinTemp] = useState(-100);
  const [maxTemp, setMaxTemp] = useState(100);

  const handleChange = (field, value) => {
    setEnvData({ ...envData, [field]: value });
    if (field === "temperatureUnit") {
      if (value === "celsius") {
        setMinTemp(-100);
        setMaxTemp(100);
      } else {
        if (value === "fahrenheit") {
          setMinTemp(-148);
          setMaxTemp(212);
        } else {
          setMinTemp(173.15);
          setMaxTemp(373.15);
        }
      }
    }
  };

  return (
    <div className="environmental-section mb-5 p-4 bg-light border rounded">
      <h5 className="text-white p-2" style={{ backgroundColor: "#243544" }}>
        Environmental Conditions
      </h5>
      <Row>
        <Col md={6}>
          <Form.Group className="mb-4">
            <Form.Label>Wind Speed</Form.Label>
            <Form.Control
              type="number"
              step="0.01"
              placeholder="Enter wind speed"
              value={envData.windSpeed}
              onChange={(e) => handleChange("windSpeed", e.target.value)}
            />
          </Form.Group>
        </Col>
        <Col md={6}>
          <Form.Group className="mb-4">
            <Form.Label>Wind Speed Unit</Form.Label>
            <Select
              options={windSpeedUnits}
              value={windSpeedUnits.find((option) => option.value === envData.windSpeedUnit)}
              onChange={(selected) => handleChange("windSpeedUnit", selected.value)}
              placeholder="Select unit"
            />
          </Form.Group>
        </Col>
      </Row>
      <Row>
        <Col md={6}>
          <Form.Group className="mb-4">
            <Form.Label>Temperature</Form.Label>
            <Form.Control
              type="number"
              step="0.01"
              placeholder="Enter temperature"
              value={envData.temperature}
              onChange={(e) => handleChange("temperature", e.target.value)}
              min={minTemp}
              max={maxTemp}
            />
          </Form.Group>
        </Col>
        <Col md={6}>
          <Form.Group className="mb-4">
            <Form.Label>Temperature Unit</Form.Label>
            <Select
              options={temperatureUnits}
              value={temperatureUnits.find((option) => option.value === envData.temperatureUnit)}
              onChange={(selected) => handleChange("temperatureUnit", selected.value)}
              placeholder="Select unit"
            />
          </Form.Group>
        </Col>
      </Row>
      <Row>
        <Col md={12}>
          <Form.Group className="mb-4">
            <Form.Label>Environmental Uncertainty</Form.Label>
            <Form.Control
              type="text"
              placeholder="Ex: +/- 10% under high wind conditions"
              value={envData.environmentalUncertainty}
              onChange={(e) => handleChange("environmentalUncertainty", e.target.value)}
            />
          </Form.Group>
        </Col>
      </Row>
    </div>
  );
};

export { EnvironmentalConditions };
